export const getSubdomainFromStorage = () => {
  return localStorage.getItem('SUBDOMAIN') ?? undefined
}

export const addSubdomainToStorage = (subdomain: string) => {
  return localStorage.setItem('SUBDOMAIN', subdomain)
}
